import script from "./SelectInputVue.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectInputVue.vue?vue&type=script&setup=true&lang=js"

import "./SelectInputVue.vue?vue&type=style&index=0&id=bedab5b6&lang=scss&scoped=true"

import exportComponent from "../../fin_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bedab5b6"]])

export default __exports__